// Import model
import { UpdateContactAppointmentRequest } from '../models/UpdateContactAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { UpdateAddressRequest } from '../models/UpdateAddressRequest';

// Import dependency serializers (for complex types)
import { UpdateAddressRequestSerializer } from './UpdateAddressRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateContactAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateContactAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateContactAppointmentRequest instance
   */
  static deserialize(json: string): UpdateContactAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateContactAppointmentRequest instance
   */
  static fromObject(obj: any): UpdateContactAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateContactAppointmentRequest');
    }


    const instance: UpdateContactAppointmentRequest = {
      address: obj['address'] ? UpdateAddressRequestSerializer.fromObject(obj['address']) : undefined as any,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      flowId: obj['flowId'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      content: obj['content'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateContactAppointmentRequest instances
   */
  static deserializeArray(json: string): UpdateContactAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateContactAppointmentRequest instance to a JSON string
   */
  static serialize(instance: UpdateContactAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateContactAppointmentRequest instance to a plain object
   */
  static toObject(instance: UpdateContactAppointmentRequest): any {
    return {
      'address': instance.address ? UpdateAddressRequestSerializer.toObject(instance.address) : undefined,
      'name': instance.name,
      'description': instance.description,
      'flowId': instance.flowId,
      'objectStatusId': instance.objectStatusId,
      'content': instance.content,
      'contentType': instance.contentType,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
    };
  }

  /**
   * Serializes an array of UpdateContactAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateContactAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
